import React, { useState, useEffect } from "react";
import { Modal, Input, message } from "antd";
import { FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import dayjs from "dayjs";
import drEasyApi from "../../Api/Customapi";

const { TextArea } = Input;

const CancelBookingModal = ({ 
  visible, 
  onCancel, 
  booking, 
  onSuccess 
}) => {
  const [cancelReason, setCancelReason] = useState("");
  const [loading, setLoading] = useState(false);

  // Reset reason when modal opens/closes
  useEffect(() => {
    if (!visible) {
      setCancelReason("");
    }
  }, [visible]);
  const formatTime = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return "";
    const [hour, minute] = timeStr.split(":");
    const hourNum = parseInt(hour, 10);
    if (isNaN(hourNum)) return timeStr;
    const ampm = hourNum >= 12 ? "PM" : "AM";
    const formattedHour = hourNum % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };

  const handleCancel = async () => {

    if (!booking) return;
    
    if (!cancelReason.trim()) {
      message.error("Please provide a reason for cancellation");
      return;
    }

    setLoading(true);
    try {
      await drEasyApi.put("/api/Book/CancelBooking", {
        id: booking.id,
        reason: cancelReason.trim()
      });

      message.success("Booking cancelled successfully");
      
      if (onSuccess) {
        onSuccess(booking.id);
      }
      
      onCancel();
    } catch (error) {
      console.error("Failed to cancel booking:", error);
      
      message.error(
        error.response?.data[0] || "Failed to cancel booking. Please try again."
      );
    }
    setLoading(false);
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <FaExclamationTriangle className="text-red-500" />
          <span>Cancel Appointment</span>
        </div>
      }
      open={visible}
      onOk={handleCancel}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Cancel Appointment"
      cancelText="Keep Appointment"
      okButtonProps={{ danger: true }}
      width={600}
      destroyOnClose
    >
      {booking && (
        <div className="space-y-7">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-medium mb-2">Appointment Details:</h4>
            <div className="space-y-1 text-sm">
              <p>
                <strong>Date:</strong> {dayjs(booking.bookingDate).format("DD MMM YYYY")}
              </p>
              <p>
                <strong>Time:</strong> {formatTime(booking.startTime)} - {formatTime(booking.endTime)}
              </p>
              <p>
                <strong>Doctor:</strong> {booking.doctorName}
              </p>
              <p>
                <strong>Clinic:</strong> {booking.clinicName}
              </p>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">
              Reason for cancellation <span className="text-red-500">*</span>
            </label>
            <TextArea
              rows={4}
              placeholder="Please provide a reason ..."
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              maxLength={500}
              showCount
            />
          </div>
          
          <div className="text-sm text-gray-600">
            <p className="flex items-start gap-2">
              <FaInfoCircle className="mt-0.5 text-blue-500 flex-shrink-0" />
              Once cancelled, this appointment cannot be restored.
            </p>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CancelBookingModal;